import { TooltipWebV3 } from '@components/TaskList/TooltipWebV3';
import React, { useState } from 'react';
import { Platform } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/RestyleIcon';
import theme from '@themes/theme';

type ChatIconWithTooltipProps = {
  onPress: (e?: any) => void;
  accessibilityLabel?: string;
};

export const ChatIconWithTooltip: React.FC<ChatIconWithTooltipProps> = ({
  onPress,
  accessibilityLabel,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box position='relative'>
      <TooltipWebV3
        marginOffset={8}
        open={tooltipOpen}
        disableHoverListener
        disableFocusListener
        disableTouchListener
        placement='bottom-end'
        variant='dark'
        title={
          <Text ml='xxs' variant='labelSmall' color='white'>
            Send Message
          </Text>
        }>
        <div
          onMouseEnter={() => {
            setTooltipOpen(true);
            setIsHovered(true);
          }}
          onMouseLeave={() => {
            setTooltipOpen(false);
            setIsHovered(false);
          }}
          onClick={(e) => {
            // Stop event propagation to prevent row click
            if (Platform.OS === 'web' && e) {
              e.stopPropagation();
            }
            onPress(e);
          }}
          style={{
            display: 'inline-flex',
            cursor: 'pointer',
            padding: theme.spacing.xs,
            borderRadius: theme.borderRadii.xs,
            // Control-on-row hover (TA-9005): grey02, one step deeper than the
            // grey01 row hover.
            backgroundColor: isHovered ? theme.colors.grey02 : 'transparent',
          }}
          role='button'
          tabIndex={0}
          aria-label={accessibilityLabel}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onPress(e);
            }
          }}>
          <Icon name='MessageSquare' variant='m' color='grey05' />
        </div>
      </TooltipWebV3>
    </Box>
  );
};

ChatIconWithTooltip.displayName = 'ChatIconWithTooltip';
